import { EWSS_GRADES } from "./registerFilters";

export { EWSS_GRADES };

export const TRAINING_NO_EWSS_GAME_COUNT_OPTIONS = [
  { value: "once", label: "Mots joués exactement 1 fois" },
  { value: "twice", label: "Mots joués exactement 2 fois" },
  { value: "onceOrTwice", label: "Mots joués 1 fois ou 2 fois" },
];

export const TRAINING_DEFAULT_NO_EWSS_GAME_COUNT = "onceOrTwice";

export const TRAINING_SPEED_OPTIONS = [15, 20, 25];

export const TRAINING_MODE_FREE = "free";
export const TRAINING_MODE_QUEST = "quest";

export const TRAINING_CONSECUTIVE_FAIL_OPTIONS = [5, 4, 3, 2];

export { POTION_AID_FILTER_OPTIONS as TRAINING_POTION_AID_FILTER_OPTIONS } from "./registerFilters";
export {
  PLAYED_COUNT_FILTER_MAX,
  PLAYED_COUNT_FILTER_OPTIONS as TRAINING_PLAYED_COUNT_OPTIONS,
} from "./registerFilters";

export const TRAINING_CATEGORY_KEYS = [
  "noyau",
  "favoris",
  "prioritaires",
  "paquet1",
  "paquet2",
  "paquet3",
  "paquet4",
  "horsPaquet",
];

export const DEFAULT_TRAINING_SETUP = {
  exactGrade: "",
  belowGrade: "",
  aboveGrade: "",
  neverPlayed: false,
  withoutEwssScore: false,
  noEwssGameCount: "",
  lastAppearanceFailed: false,
  consecutiveFails: false,
  consecutiveFailsCount: 2,
  categories: {
    noyau: false,
    favoris: false,
    prioritaires: false,
    paquet1: false,
    paquet2: false,
    paquet3: false,
    paquet4: false,
    horsPaquet: false,
  },
  livre: "",
  auteur: "",
  captureYear: "",
  illustration: "",
  groupement: "",
  groupementId: "",
  potionsUsed: false,
  potionsUsedFilter: "memory",
  playedCountMin: "",
  playedCountMax: "",
  speedSeconds: 20,
  withRepetition: false,
};

export function isTrainingCategoryActive(categories = DEFAULT_TRAINING_SETUP.categories) {
  return TRAINING_CATEGORY_KEYS.some((key) => Boolean(categories[key]));
}
